import React from 'react';
import style from 'acscp/components/itinerary/itineraryFieldHeadings.module.scss';
import classNames from 'classnames';
import { Booking } from 'acscp/store';
import { ButtonRow } from 'acscp/components/common/buttonRow';
import { Row } from 'acscp/components/common/row';
import { FormattedMessage } from 'react-intl';
import { PrintButton } from 'acscp/components/itinerary/printButton';
import { TimeType } from 'acscp/api/models/customTypes/timeType';

interface ItineraryFieldHeadingsProps {
    bookingDetails?: Booking;
}

export class ItineraryFieldHeadings extends React.Component<ItineraryFieldHeadingsProps, {}>  {
    render(): JSX.Element {
        return (
            <Row>
                {this.props.bookingDetails &&
                <ButtonRow
                    className={style.MobileOnlyButtons}
                    bookingDetails={this.props.bookingDetails}
                >
                    <PrintButton />
                </ButtonRow>
                }
                <div className={style.HeadersWrapper}>
                    <div className={classNames(style.Header, style.Label)}/>
                    <div className={classNames(style.Header, style.Depart)}>
                        <FormattedMessage
                            id={'web.components.itineraryLegs.Depart'}
                            defaultMessage={'DEPART'}
                        />
                    </div>
                    <div className={classNames(style.Header, style.Arrive)}>
                        <FormattedMessage
                            id={'web.components.itineraryLegs.Arrive'}
                            defaultMessage={'ARRIVE'}
                        />
                    </div>
                    <div className={classNames(style.Header, style.Date)}>
                        <FormattedMessage
                            id={'web.components.itineraryLegs.Date'}
                            defaultMessage={'DATE'}
                        />
                    </div>
                    <div className={classNames(style.Header, style.DepartTime)}>
                        {(this.props.bookingDetails && this.props.bookingDetails.legs.length > 0
                            && this.props.bookingDetails.legs[0].departureTimeType === TimeType.UTC)
                            ? <FormattedMessage
                                id={'web.components.itineraryLegs.DepartureTimeUTC'}
                                defaultMessage={'DEPART (UTC)'}
                            />
                            : <FormattedMessage
                                id={'web.components.itineraryLegs.DepartureTimeLocal'}
                                defaultMessage={'DEPART (local)'}
                            />
                        }
                    </div>
                    <div className={classNames(style.Header, style.ArriveTime)}>
                        {(this.props.bookingDetails && this.props.bookingDetails.legs.length > 0
                            && this.props.bookingDetails.legs[0].arrivalTimeType === TimeType.UTC)
                            ? <FormattedMessage
                                id={'web.components.itineraryLegs.ArrivalTimeUTC'}
                                defaultMessage={'ARRIVE (UTC)'}
                            />
                            : <FormattedMessage
                                id={'web.components.itineraryLegs.ArrivalTimeLocal'}
                                defaultMessage={'ARRIVE (local)'}
                            />
                        }
                    </div>
                    <div className={classNames(style.Header, style.Duration)}>
                        <FormattedMessage
                            id={'web.components.itineraryLegs.Duration'}
                            defaultMessage={'DURATION'}
                        />
                    </div>
                    <div className={classNames(style.Header, style.Passengers)}>
                        <FormattedMessage
                            id={'web.components.itineraryLegs.Passengers'}
                            defaultMessage={'PASSENGERS'}
                        />
                    </div>
                </div>
            </Row>
        );
    }
}
